import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalService} from '../../../../services/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-component-input-inline',
    templateUrl: './input-inline.component.html',
    styleUrls: ['./input-inline.component.scss']
})
export class InputInlineComponent implements OnInit {
    @Input() public value = '';
    @Input() public bold = false;
    @Input() public clearValue = false;
    @Input() public editByPen = false;
    @Input() public isNeedConfirm = false;

    @Output() public emitSave: EventEmitter<string> = new EventEmitter<string>();

    public copyValue = '';
    public isShowInput = false;

    constructor(
        private modalService: ModalService,
        public translate: TranslateService,
    ) {
    }

    ngOnInit(): void {
    }

    onShowInput(event?: MouseEvent): void {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        if (this.isNeedConfirm) {
            const modalSettings: any = {
                modalHeader: this.translate.instant('CONFIRM.HEADERS.ATTENTION'),
                modalBody: this.translate.instant('CONFIRM.TEXT.CHANGES'),
                buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
                buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
            };
            const confirmModal = this.modalService.createFromSettings(modalSettings);
            confirmModal.result.then(data => {
                if (data) {
                    this.openEditor();
                }
            }).catch(() => {
                return;
            });
        } else {
            this.openEditor();
        }
    }

    openEditor(): void {
        this.isShowInput = true;
        if (this.clearValue) {
            this.copyValue = this.value;
            this.value = '';
        }
    }

    onHideInput(): void {
        if (!this.value && this.clearValue) {
            this.value = this.copyValue;
        }
        this.isShowInput = false;
    }

    onSave(el): void {
        this.value = el.value.trim();
        this.onHideInput();
        this.emitSave.emit(el.value.trim());
    }

    onCancel(): void {
        this.onHideInput();
    }

}
